import React from 'react';
import MUIPopper, {
  PopperProps as MUIPopperProps,
} from '@material-ui/core/Popper';

interface PopperProps extends MUIPopperProps {}

const Popper = (props: PopperProps) => {
  return <MUIPopper {...props}>{props.children}</MUIPopper>;
};

Popper.displayName = 'Popper';

export default Popper;
